import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'lightbox-flex-item' }, React.createElement('div', {
        'className': 'lightbox-option-round lightbox-option-round-new ' + (this.props.disabled ? 'disabled' : ''),
        'onClick': this.props.showNewFeature
    }, React.createElement('div', { 'className': 'new-feature' }, React.createElement('span', {}, 'Add ', this.props.group))));
}